import { DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../../_services/langhfre.service';
import * as $ from 'jquery';
import { NavigationService } from 'src/app/_services/navigation.service';
import { ToastrService } from 'ngx-toastr';
import { WebsiteService } from 'src/app/_services/website.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoadScriptService } from 'src/app/_services/load-script.service';

@Component({
  selector: 'app-documark',
  templateUrl: './documark.component.html',
  styleUrls: ['./documark.component.scss']
})
export class DocumarkComponent implements OnInit {

  contactForm: FormGroup;
  formSection: boolean = true;
  thankSection: boolean = false;
  country: string;
  isSubmitting: boolean = false;

  constructor(
    private toastr: ToastrService,
    private networkCall: WebsiteService,
    private fb: FormBuilder,
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    private router: Router,
    public loadScript: LoadScriptService,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document, 
    public navigationService: NavigationService
  ) { 
    this.contactForm = fb.group({
      'contactFormName': ['', Validators.required],
      'contactFormEmail': ['', Validators.compose([Validators.required, Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/)])],
      'contactphoneNo': ['', Validators.required],
      'DesignationTypes': ['', Validators.required],
      'website': ['']
    });
  }

  ngOnInit(): void {
    this.titleService.setTitle('Trinka DocuMark｜高校與科研機構的學術誠信整體解決方案');
    this.metaTagService.updateTag({ name: 'description', content: "DocuMark以先進的來源追蹤技術識別AI生成、人工撰寫或複製粘貼的內容，有效保障學術誠信。" });
    this.metaTagService.updateTag({ property: 'og:title', content: 'Trinka DocuMark｜高校與科研機構的學術誠信整體解決方案' });
    this.metaTagService.updateTag({ property: 'og:description', content: "DocuMark以先進的來源追蹤技術識別AI生成、人工撰寫或複製粘貼的內容，有效保障學術誠信。" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/features/documark' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/features/documark/documark.png' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'Trinka DocuMark｜高校與科研機構的學術誠信整體解決方案' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "DocuMark以先進的來源追蹤技術識別AI生成、人工撰寫或複製粘貼的內容，有效保障學術誠信。" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/features/documark/documark.png' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/features/documark' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/features/documark' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/features/documark' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/features/documark' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/features/documark' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/features/documark' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/features/documark' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/features/documark' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/features/documark' });

   
  }

  sendContactUsForm() {
    if (this.contactForm.value.website) {
      console.warn('Spam detected');
      return;
    }
  
    if (this.contactForm.invalid) {
      this.validateAllFormFields(this.contactForm);
      return;
    }
  
    this.isSubmitting = true;
  
    if (!localStorage.getItem("country-trinka")) {
      this.loadGeoAPIScript();
    }
    this.country = localStorage.getItem("country-trinka") || "en";
  
    const name = this.contactForm.value.contactFormName;
    const designation = this.contactForm.value.DesignationTypes;
    const phone = this.contactForm.value.contactphoneNo;
    const email = this.contactForm.value.contactFormEmail;
    const source = this.router.url || 'N/A';
  
    const query = `${name}||${designation}||${phone}`;
  
    const payload = {
      email,
      query,
      source
    };
  
    this.networkCall.postContactUs(email, query, source).subscribe({
      next: () => {
        this.toastr.success("Thanks! We will contact you shortly.");
        this.formSection = false;
        this.thankSection = true;
        this.contactForm.reset();
      },
      error: () => {
        this.toastr.warning("Something went wrong!");
      }
    }).add(() => {
      this.isSubmitting = false;
    });
  }

  loadGeoAPIScript() {
    if (isPlatformBrowser(this.platformId)) {
      var scriptName = "geoIP"
      this.loadScript.loadScript(scriptName, '//geoip-js.com/js/apis/geoip2/v2.1/geoip2.js')
        .then(() => {
          console.log(`${scriptName} loaded successfully`);
          var onSuccess = function (location) {
            localStorage.setItem("country-trinka", location['country']['iso_code'])
          };

          var onError = function (error) {
            localStorage.setItem("country-trinka", "IN")
          };
          try {
            //@ts-ignore
            geoip2.city(onSuccess, onError);
          } catch (error) {
            console.log(error)
          }
        })
        .catch(() => {
          console.error(`Failed to load ${scriptName}`);
        });
    }
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof FormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }
  

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }

  stopAllVideos() {
    const iframes = Array.from(document.querySelectorAll('iframe.youtubeVideoForTryDemo'));
    iframes.forEach((iframe) => {
        const htmlIframe = iframe as HTMLIFrameElement;
        htmlIframe.src = htmlIframe.src;
    });
  }

}
